<div class="container">
    <lib-generic-dropdown
        [(selectedItem)]="selectedItem"
        (selectedItemChange)="onSelectedItemChange()"
        [source]="source"
        [config]="{
            defaultText: 'Select ' + label,
            itemDisplayKey: 'name'
        }"
        [isReadOnly]="isReadOnly"
        [error]="!isValid"
    ></lib-generic-dropdown>
    <app-validation-error-message [show]="!isValid" [errors]="validationErrors"></app-validation-error-message>
</div>
